import { flowResult } from 'mobx';
import { ReactNotifications } from '../../components';
import { MSG } from '../configs/constants';
import { useStore } from './hook';

export const useBuyCourse = (courseId, { onSuccess, onAfterCancel } = {}) => {
    const {
        courseStore: { studentBuyCourse, getAttendingCourseForCancel },
        authStore: { token },
        modalStore: { hide, openAlert, openWarningModal, openErrorModal },
        userStore: { userInfoHeader, onAddTicketPlan, cancelAttendance }
    } = useStore();

    const handleBuyCourse = async (event) => {
        event?.stopPropagation();
        if (!token) {
            openAlert(MSG['warning.student.apply.ticket'], () => { hide(); });
            return;
        }
        if (userInfoHeader?.numberTicket == 0) {
            onAddTicketPlan();
            return;
        }
        const res = await flowResult(studentBuyCourse(courseId, true));
        if (res?.ok) {
            onSuccess?.();
        } else {
            const isAttendingError = res?.message === MSG['error.attending.course.no.cancel'];
            const attendingCourse = isAttendingError ? await flowResult(getAttendingCourseForCancel()) : null;
            const errorMsg = attendingCourse
                ? MSG['error.attending.course.with.cancel']
                : isAttendingError
                    ? MSG['error.attending.course.no.cancel']
                    : res?.message || MSG['api.response.no_message'];
            const actionButton = attendingCourse ? (
                <div className='mg-t-10 mb-2 d-flex justify-content-center'>
                    <button
                        type='button'
                        className='cancel-attendance-modal-btn'
                        onClick={() => {
                            hide();
                            let isProcessing = false;
                            openWarningModal(MSG['cancel.attendance.update.confirm'], async () => {
                                if (isProcessing) return;
                                isProcessing = true;
                                try {
                                    const cancelRes = await flowResult(cancelAttendance(attendingCourse.id));
                                    if (cancelRes) {
                                        onAfterCancel?.();
                                        ReactNotifications('success', MSG['inform.success.cancel.attendance']);
                                    } else {
                                        ReactNotifications('error', MSG['api.response.no_message']);
                                    }
                                } finally {
                                    isProcessing = false;
                                }
                            });
                        }}>
                        受講をキャンセル
                    </button>
                </div>
            ) : null;
            openErrorModal('エラー', errorMsg, 'small', actionButton);
        }
    };

    return handleBuyCourse;
};
